import styled from 'styled-components';
import { fontFamily } from '../../../constants';
import { Button } from '../../Common/Button/Button.view';
import {
  BodyContainer as BodyContainerTemp,
  HeaderContainer as HeaderContainerTemp,
  Header as HeaderTemp,
  NormalContent as NormalContentTemp,
  ContentTextTemp,
  DetailsContainerTemp,
  DetailSectionTemp,
  CommentInputContainerTemp
} from '../../Common/CommonStyles';
import { device, fontSize, minDevice } from '../../constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* height: 100%; */
  height: 84vh;
`;

export const HeaderContainer = styled(HeaderContainerTemp)`
  & * {
    fill: ${({ theme }) => theme.contrast.primary} !important;
  }

  &.inner {
    margin: 0rem;
    border-bottom: 1px solid #707070;
    & > div {
      display: flex;
      & > div {
        margin-right: 2rem;
      }
    }
  }
`;

export const BodyContainer = styled(BodyContainerTemp)`
  /* background-color: #ffffff; */
  flex: 1;
  margin: 1.5rem 1%;
  /* box-shadow: -5px -5px 11px #fffffff5; */
  border-radius: 10px;
  overflow: auto;
  flex-direction: column;
  height: 50vh;
  /* background-color: pink; */
`;

export const NormalContent = styled.p`
  color: #8e8e8e;
  font: 1.8rem ${fontFamily.circularMedium};

  &.imp {
    /* margin-left: 2rem; */
    color: #202020;
    /* font-family: ${fontFamily.circularBook}; */
  }
`;

export const StatusColor = styled.div`
  height: 14px;
  width: 18px;
  border-radius: 10px;
  background-color: #42fe00;
`;

export const SpacedDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StatusContainer = styled(SpacedDiv)`
  margin: 1rem 0rem;
`;

export const UpdatedStatusText = styled.div`
  color: #393939;
  font: 1.4rem ${fontFamily.circularBook};
`;

export const HeaderText = styled(HeaderTemp)`
  position: relative;
  display: flex;
  justify-content: center;
  font-family: ${fontFamily.circularMedium};
  font-size: 1.6rem;
  &.inner {
    cursor: pointer;
  }

  /* &.active {
    background-color: red;
  } */
`;

export const DetailsContainer = styled(DetailsContainerTemp)`
  /* background-color: red; */
  flex-wrap: wrap;
  display: flex;
`;

export const LabelContainer = styled.div``;

export const DetailSection = styled(DetailSectionTemp)``;

export const ActiveDivider = styled.div`
  position: absolute;
  bottom: calc(-1.2rem - 1.5px);
  width: 60%;
  height: 3px;
  border-radius: 3px;
  background-color: #000000;
`;

export const CommentInputContainer = styled(CommentInputContainerTemp)``;

export const InputCommentContainer = styled.div`
  padding-left: 6rem;
  margin-bottom: 1rem;
`;

export const SidePanelContainer = styled.div`
  flex: 1;
  /* border: 1px solid #707070; */
  border-radius: 10px;
  /* height: 100%; */
  /* margin: 1rem 0rem 1rem 1rem; */
  overflow-y: auto;
`;

export const ItemContainer = styled.div`
  background-color: #f4f4f8;

  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.shadowout};
  margin: 2rem 2.5rem 0rem 2.5rem;
  padding: 2rem;
  & .mainDetails {
    font: 1.8rem ${fontFamily.circularMedium};
    color: #4a4a4a;
    margin-bottom: 0.5rem;
  }

  & .subDetails {
    font: 1.4rem ${fontFamily.circularMedium};
    color: #393939;
  }

  &.selectedFile {
    color: #393939;
    background-color: #afafbb;
  }

  &.partRequest {
    @media ${minDevice.tablet} {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 6rem;
`;

export const StatusBtnContainer = styled.div`
  margin-bottom: 2rem;
  & > button {
    margin-right: 3rem;
  }
`;

export const ButtonWrap = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const WrapperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const NormalText = styled.div`
  color: #717171;
  font: 2rem ${fontFamily.circularMedium};
  &.hightlight {
    color: #000000;
  }
`;
export const Main = styled.div`
  width: 100%;
  height: 100%;
  /* overflow-y: auto; */
  padding-right: 5px;
`;

export const AddButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.customTheme.primary};
  font-size: 16px;
  padding: 1rem;
  text-decoration: underline;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
  }
`;

export const LabelToolTip = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.customTheme.primary};
  width: max-content;
  max-width: 350px;
  /* height: fit-content; */

  /* display: flex; */
  display: none;
  justify-content: center;
  align-items: center;
  /* bottom: -15px; */
  left: 0;
  border-radius: 4px;
  z-index: 1;
  padding: 5px 10px;
  top: -100%;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 100%;
    width: 0;
    height: 0;
    border-bottom: 5px solid ${({ theme }) => theme.customTheme.primary};
    border-top: 5px solid transparent;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
  }
  &.top {
    top: -4.2rem;
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 100%;
      left: 10%;
      width: 0;
      height: 0;
      border-top: 5px solid ${({ theme }) => theme.customTheme.primary};
      border-bottom: 5px solid transparent;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
    }
  }
`;

export const ContentText = styled(ContentTextTemp)`
  font-size: 1.6rem;
  position: relative;
  display: flex;
  align-items: center;
  &:hover ${LabelToolTip} {
    display: flex;
  }
  &.table {
    padding: 2rem 0rem 1rem;
  }
`;

export const ButtonComponent = styled(Button)`
  /* background: red; */
`;

export const CountSpan = styled.div`
  position: absolute;
  bottom: 3rem;
  right: 2rem;
  background: white;
  color: black;
  border-radius: 8px;
  width: 12px;
`;

export const AddPartsDisplay = styled.div`
  width: 100%;
  height: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${fontSize.titleBig};
  font-family: ${fontFamily.circularMedium};
  color: ${({ theme }) => theme.text.gray};
`;

export const ModalListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 97%;
  z-index: 2;
  height: 8rem;
  padding: 3rem;
  background: #eeeff5;
`;

// export const LogsContainer = styled.div`
//   padding: 2px;
//   max-height: 28rem;
//   overflow-y: auto;
// `;

export const RemarkContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  width: 100%;
`;

export const EditorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const EditorBtn = styled.div`
  padding-top: 4rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  width: 100%;
  padding-bottom: 1rem;
`;

export const DetailsDropdownContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.contrast.primary};
  padding: 1rem 1rem;
`;

export const SelectableText = styled.div`
  font-size: ${fontSize.title};
  font-family: ${fontFamily.circularMedium};
  color: ${({ theme }) => theme.text.gray};
`;

export const DetailWrapper = styled.div`
  background-color: ${({ theme }) => theme.body};
  padding: 2rem;
  /* height: 30rem; */
  /* overflow: auto; */
  margin-top: 1rem;
  transition: max-height 0.3s ease, opacity 0.3s ease;
  display: none;

  &.visible {
    display: block;
    opacity: 1;
  }
`;

export const PartRequestContainer = styled.div`
  background-color: #e8e8f1;
  padding: 2rem;
  border-radius: 10px;
  margin-bottom: 2rem;
`;

export const SidePanelIconDragger = styled.div`
  width: 90%;
  height: 6rem;
  background-color: ${({ theme }) => theme?.body};
  position: fixed;
  bottom: 0;
  left: 5%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  display: flex;
  align-items: center;
  padding: 2rem;
  justify-content: center;
  gap: 7rem;
  z-index: 99;
`;

export const SidePanelIcon = styled.div`
  width: 60px;
  height: 40px;
  position: fixed;
  bottom: 6rem;
  left: calc(50% - 30px);
  background-color: ${({ theme }) => theme?.body};
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
`;

export const PartsContainer = styled.div`
  background-color: #e8e8f1;
  border-radius: 10px;
  padding: 2rem 1rem;
  margin-bottom: 1rem;
  overflow-x: auto;
  max-width: calc(100vw - 2rem);
`;

export const PartHeader = styled.div`
  display: flex;
`;

export const PartImage = styled.img`
  object-fit: contain;
`;

export const PartName = styled.div`
  margin-top: 2rem;
  margin-left: 2rem;
  font-size: ${fontSize.text};
  font-family: ${fontFamily.circularBold};
  color: #2f2f2f;
`;

export const PartDetailsContainer = styled.div`
  margin-top: 2rem;
`;

export const DetailLabel = styled.div`
  font-size: ${fontSize.title};
  font-family: ${fontFamily.circularMedium};
  color: #9b9b9b;
  min-width: 15rem;
`;

export const DetailText = styled.div`
  color: #2f2f2f;
  font-size: ${fontSize.title};
  font-family: ${fontFamily.circularMedium};
`;

export const EnlargedImage = styled.img`
  width: 100%;
  height: 100%;
`;
